import { render, staticRenderFns } from "./ViAnnouncements.vue?vue&type=template&id=b910f822"
import script from "./ViAnnouncements.vue?vue&type=script&lang=js"
export * from "./ViAnnouncements.vue?vue&type=script&lang=js"
import style0 from "./ViAnnouncements.vue?vue&type=style&index=0&id=b910f822&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports